export enum EventInterval {
  ONCE = 0,
  WEEKLY = 1,
  TWO_WEEKS = 2,
  THREE_WEEKS = 3,
  MONTH = 4,
}
